"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _getChallengeTimeframeData = _interopRequireDefault(require("./getChallengeTimeframeData"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getChallengeTimeframeLiteral = function getChallengeTimeframeLiteral(_ref) {
  var start = _ref.start,
      end = _ref.end,
      t = _ref.t;
  var timeframeValues = (0, _getChallengeTimeframeData["default"])({
    start: start,
    end: end
  });
  var days = timeframeValues.days,
      hours = timeframeValues.hours,
      minutes = timeframeValues.minutes,
      seconds = timeframeValues.seconds,
      timeframe = timeframeValues.timeframe;
  var futureLiteralTime = '';

  if (seconds > 0) {
    futureLiteralTime = 'ds-challenges.timeframe.start_seconds_plural';
  }

  if (minutes > 0) {
    futureLiteralTime = 'ds-challenges.timeframe.start_minutes_plural';
  }

  if (hours > 0) {
    futureLiteralTime = 'ds-challenges.timeframe.start_hours_plural';
  }

  if (days > 0) {
    futureLiteralTime = 'ds-challenges.timeframe.start_days';
  }

  var key = timeframe !== 'past' ? timeframe === 'future' ? futureLiteralTime : 'ds-challenges.timeframe.remainingtime' : 'ds-challenges.timeframe.start';
  return t(key, _objectSpread({}, timeframeValues));
};

var _default = getChallengeTimeframeLiteral;
exports["default"] = _default;
//# sourceMappingURL=getChallengeTimeframeLiteral.js.map